import React from "react";
import "../styles/Home.css";

const Home = () => {
  return (
    <div className="home">
      <header className="home-header">
        <h1>Smart Water Management System</h1>
        <p>Efficient, sustainable, and intelligent water usage for the future.</p>
      </header>
      <section className="home-content">
        <h2>Why Smart Water Management?</h2>
        <p>
          Water is a vital resource, and managing it efficiently is crucial for sustainable urban living. Traditional water systems often suffer from issues like leaks, wastage, and inefficient distribution. Our Smart Water Management System aims to address these challenges through real-time monitoring, automated leak detection, optimized distribution, and user water tracking.
        </p>
        <div className="features">
          <h3>Key Features:</h3>
          <ul>
            <li><strong>Leak Detection & Prevention:</strong> Real-time detection of leaks through pressure sensors to prevent water loss.</li>
            <li><strong>Optimized Water Distribution:</strong> Adjusts water supply based on real-time demand to ensure balanced distribution.</li>
            <li><strong>User Water Tracking:</strong> Allows users to monitor their water usage and reduce waste with real-time data.</li>
            <li><strong>Automated Alerts & Notifications:</strong> Notifies users and authorities about leaks, high consumption, or unusual usage patterns.</li>
          </ul>
        </div>
      </section>
      <footer className="home-footer">
        <p>&copy; 2025 Smart Water Management. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Home;
